import { render, staticRenderFns } from "./RequirementSearchByIds.vue?vue&type=template&id=76652b4d&scoped=true&"
import script from "./RequirementSearchByIds.vue?vue&type=script&lang=ts&"
export * from "./RequirementSearchByIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76652b4d",
  null
  
)

export default component.exports